/**
 * 并发数不够的消息
 */
import { Button } from 'antd';
import React, { useState } from 'react';
import ErrorIcon from '/public/error.svg';
import { IconWrapper } from '../ui/icon-wrapper';
import { useI18n } from '@/hooks/use-i18n';

interface NotCompletedTaggingMsgProps {
  onContinue: () => void;
}

const NotCompletedTaggingMsg: React.FC<NotCompletedTaggingMsgProps> = ({
  onContinue,
}) => {
  const { t } = useI18n(['thread', 'common']);
  const [isLoading, setIsLoading] = useState(false);

  const handleContinue = async () => {
    setIsLoading(true);
    try {
      await onContinue();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-between  bg-[#F4F4F5] border border-solid border-[#E5E5E5] rounded-[8px] px-[10px] py-[12px] mt-[16px]">
      <span className="flex items-center gap-2">
        <ErrorIcon className="w-4 h-4" />
        <span className="text-[#000000BF] font-semibold text-[14px]">
          {t('thread:message.notCompletedTagging.question')}
        </span>
      </span>
      <Button
        size="small"
        shape="round"
        loading={isLoading}
        onClick={handleContinue}
        className="!px-[8px] !py-[3px] !text-primary !text-[13px] !border-primary"
      >
        {t('common:continueExecution')}
      </Button>
    </div>
  );
};

export default NotCompletedTaggingMsg;
